export default __webpack_public_path__ + "static/media/edit_ic.ced0eb5e.svg";